import { EventEmitter, Injectable } from '@angular/core';
export interface IModal {
    id: string;
    isOpen: boolean;
    open(): void;
    close(): void;
}

@Injectable({
    providedIn: 'root'
})
export class ModalService {

    public onModalOpened: EventEmitter<string> = new EventEmitter<string>();
    private modals: IModal[] = [];
    constructor() { }

    closeAll() {
        if (this.modals.length > 0) {
            this.modals.forEach(k => {
                // console.log(k.id);
                if (k.id != "modal-error") {
                    k.close();
                }
            })
        }
    }

    add(modal: IModal) {
        // add modal to array of active modals
        this.modals.push(modal);
    }

    remove(id: string) {
        // remove modal from array of active modals
        this.modals = this.modals.filter(x => x.id !== id);
    }

    open(id: string) {
        // Close other modals before opening a new one to prevent stacking
        // EXCEPTION: Don't close others if we are opening a spinner or an error modal
        if (id !== 'spinner-modal' && id !== 'modal-error') {
            this.modals.forEach(modal => {
                if (modal.id !== id && modal.id !== 'modal-error' && modal.isOpen) {
                    modal.close();
                }
            });
        }

        const modalToOpen = this.modals.find(modal => modal.id === id);
        if (modalToOpen && !modalToOpen.isOpen) {
            modalToOpen.open();
            this.onModalOpened.emit(id);
        } else {
            console.warn(`Modal with id "${id}" does not exist or is already open.`);
        }
    }

    close(id: string) {
        const modalToClose = this.modals.find(modal => modal.id === id);
        if (modalToClose) {
            modalToClose.close();
        } else {
            console.warn(`Modal with id "${id}" does not exist.`);
        }
    }

}
